/* tslint:disable */
/* eslint-disable */
/**
 * OU-AAO API
 * This is a definition of Osaka University AAD Application API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: t.shinohara@mmj.ne.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SignInRequest
 */
export interface SignInRequest {
  /**
   *
   * @type {string}
   * @memberof SignInRequest
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof SignInRequest
   */
  password: string
}

export function SignInRequestFromJSON(json: any): SignInRequest {
  return SignInRequestFromJSONTyped(json, false)
}

export function SignInRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    email: json['email'],
    password: json['password'],
  }
}

export function SignInRequestToJSON(value?: SignInRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    email: value.email,
    password: value.password,
  }
}
